/**
 * Default Representative & Notification Address values for all advisor cases.
 * Shown when Mongo `collected_fields` has no value for that key; non-empty stored values override.
 */

export const DEFAULT_REPRESENTATIVE_COLLECTED = {
  empresa_representante: 'Global Mobility Law S.L.',
  documento_representante: 'B12345678',
  domicilio_representante: 'Calle de Serrano 55',
  numero_domicilio_representante: '3',
  piso_representante: '2ª Planta',
  localidad_representante: 'Madrid',
  codigo_postal_representante: '28006',
  provincia_representante: 'Madrid',
  telefono_representante: '+34 910 123 456',
  email_representante: 'legal@globalmobility.law',
};

export const DEFAULT_NOTIFICATION_COLLECTED = {
  nombre_notificaciones: 'Global Mobility Law S.L.',
  documento_notificaciones: 'B12345678',
  domicilio_notificaciones: 'Calle de Serrano 55',
  numero_domicilio_notificaciones: '3',
  piso_notificaciones: '2ª Planta',
  localidad_notificaciones: 'Madrid',
  codigo_postal_notificaciones: '28006',
  provincia_notificaciones: 'Madrid',
  telefono_notificaciones: '+34 910 123 456',
  email_notificaciones: 'legal@globalmobility.law',
  /** Stored value; must match advisor edit select options (`Yes` / `Sí` / `No`). */
  notificaciones_electronicas: 'Yes, consented',
};

/**
 * Normalizes electronic-notification consent for display / PDF (short Yes / No).
 * Accepts Spanish or English values from Mongo. UI adds a green tick for "Yes" in DetailsGrid.
 */
export function formatElectronicNotificationsDisplay(raw) {
  if (raw == null || raw === '-' || String(raw).trim() === '') return '-';
  const s = String(raw).trim().toLowerCase();
  const normalized = s.normalize('NFD').replace(/\p{M}/gu, '');
  if (['si', 'sí', 'yes', 'y', 'true', '1'].includes(s) || normalized === 'si') {
    return 'Yes';
  }
  if (['no', 'false', '0'].includes(s)) {
    return 'No';
  }
  return String(raw);
}

/** Display line: first non-empty among `keys` in collected, else same keys in defaults, else em dash. */
export function displayCollectedLine(collected, defaults, ...keys) {
  const src = collected && typeof collected === 'object' ? collected : {};
  for (const k of keys) {
    const v = src[k];
    if (v !== undefined && v !== null && String(v).trim() !== '') return String(v);
  }
  if (defaults && typeof defaults === 'object') {
    for (const k of keys) {
      if (!(k in defaults)) continue;
      const d = defaults[k];
      if (d !== undefined && d !== null && String(d).trim() !== '') return String(d);
    }
  }
  return '-';
}

/** Edit form initial value for a single Mongo field key. */
export function effectiveStringForEdit(collected, defaults, apiKey) {
  const src = collected && typeof collected === 'object' ? collected : {};
  const v = src[apiKey];
  if (v !== undefined && v !== null && String(v).trim() !== '') return String(v);
  const d = defaults?.[apiKey];
  if (d !== undefined && d !== null && String(d).trim() !== '') return String(d);
  return '';
}
